import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 29px;
  border-bottom: 1px solid #4e5574;
`;

export const ImageWrapper = styled.div`
  width: 28px;
  height: 28px;
  cursor: pointer;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: center;
  text-align: center;
`;

export const PreviewTitleText = styled.span<{color?: string}>`
  color: ${(props) => (props.color ? props.color : "#858e97")};
  font-size: 20px;
  font-weight: 600;
  text-align: center;
`;

export const TitleText = styled.span<{color?: string}>`
  text-align: center;
  color: ${(props) => props.color};

  font-size: 16px;
  font-weight: 700;
  line-height: 18px;
  text-align: center;
`;
